import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import SelectAsync from 'react-select/async';
import { NavLink } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { Button } from '@mui/material';
import DocumentModal from './Modal/DocumentModal.jsx';
import ArchiveIcon from '@mui/icons-material/Archive';



export default class Document extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'document',
            id: props.Id,
            isNew: props.IsNew,
            data: {
                bodies: []
            },
            loading: true,
            bodyVersion: '',
            t_bed: 0,
            t_bes: 0,
            modalOpen: false,
            documentItemId: null,
            currentArchiveIds: null,
            tafsilOptions4: [], // نگهداری تفصیلی‌های سطح چهارم برای هر record 
            tafsilOptions5: [], // نگهداری تفصیلی‌های سطح پنجم برای هر record
            moeinCodes: {},

        };
    }



    componentDidMount() {
        this.httpPost("api/v1/document/get", {
            id: this.getCurrentFormId(),
            isNew: this.state.isNew
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.companyId = data.global.company.id;

                    if (data.bodies.length <= 0) data.bodies.push(this.getBlankRow(1));

                    for (var i = 0; i < data.bodies.length; i++) {
                        this.state.t_bed += data.bodies[i]["bed"];
                        this.state.t_bes += data.bodies[i]["bes"];
                    }

                    this.setState({
                        data: data,
                        loading: false
                    })


                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    componentDidUpdate(prevProps, prevState) {

        this.state.data.bodies.forEach((record, index) => {
            if (prevState.moeinCodes[index] !== this.state.moeinCodes[index]) {


                // فراخوانی loadAccountOptions برای تفصیلی سطح چهارم
                this.loadAccountOptions('', options => {
                    this.setState(prevState => ({
                        tafsilOptions4: {
                            ...prevState.tafsilOptions4,
                            [index]: options
                        }
                    }));
                }, 4, this.state.moeinCodes[index], record.tafsilType4, record.tafsilType5);

                // فراخوانی loadAccountOptions برای تفصیلی سطح پنجم
                this.loadAccountOptions('', options => {
                    this.setState(prevState => ({
                        tafsilOptions5: {
                            ...prevState.tafsilOptions5,
                            [index]: options
                        }
                    }));
                }, 5, this.state.moeinCodes[index], record.tafsilType4, record.tafsilType5);
            }
        });
    }



    updateStateForMoeinCode(index, e) {
        this.setState(prevState => ({
            moeinCodes: {
                ...prevState.moeinCodes,
                [index]: e.value
            },
            tafsilOptions4: {
                ...prevState.tafsilOptions4,
                [index]: e.value
            },
            tafsilOptions5: {
                ...prevState.tafsilOptions5,
                [index]: e.value
            }
        }), () => {


            // فراخوانی loadAccountOptions برای تفصیلی سطح چهارم
            //setTimeout(() => {
            //    this.loadAccountOptions('', options => {
            //        console.log(`داده‌های سطح چهارم برای سطر ${index}: `, options);
            //        this.setState(prevState => ({
            //            tafsilOptions4: {
            //                ...prevState.tafsilOptions4,
            //                [index]: options
            //            }
            //        }));
            //    }, 4, e.value, this.state.data.bodies[index].tafsilType4, this.state.data.bodies[index].tafsilType5);
            //}, 0);

            //// فراخوانی loadAccountOptions برای تفصیلی سطح پنجم
            //setTimeout(() => {
            //    this.loadAccountOptions('', options => {
            //        this.setState(prevState => ({
            //            tafsilOptions5: {
            //                ...prevState.tafsilOptions5,
            //                [index]: options
            //            }
            //        }));
            //    }, 5, e.value, this.state.data.bodies[index].tafsilType4, this.state.data.bodies[index].tafsilType5);
            //}, 0);
        });
    }





    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/document/save", {
            id: this.state.data.record.id,
            number: this.state.data.record.number,
            companyId: this.state.data.global.company.id,
            refNumber: this.state.data.record.refNumber,
            description: this.state.data.record.description,
            datePersian: this.state.data.record.datePersian,
            note: this.state.data.record.note,
            status: this.state.data.record.status,
            type: this.state.data.record.type,
            moeinDetailed: false,

            bodies: this.state.data.bodies,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/documents'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }





    setBodyValue(id, field, value) {
        this.state.t_bed = 0;
        this.state.t_bes = 0;

        const updatedBodies = this.state.data.bodies.map(body => {
            if (body.id === id) {
                if (field === 'moeinCode' || field === 'tafsilCode' || field === 'tafsilCode5') {
                    body[field] = value.value;
                } else {
                    body[field] = value;
                }

                if (field === 'moeinCode') {
                    body.moeinDetailed = value.moeinDetailed;
                    body.moeinDetailed5 = value.moeinDetailed5;
                    body.tafsilType4 = value.tafsilType4;
                    body.tafsilType5 = value.tafsilType5;

                    if (!value.moeinDetailed) {
                        body.tafsilCode = 0;
                    }
                    if (!value.moeinDetailed5) {
                        body.tafsilCode5 = 0;
                    }
                }

                if (this.isBlank(body.bed)) body.bed = 0;
                if (this.isBlank(body.bes)) body.bes = 0;
            }

            this.state.t_bed = this.FixedPointNumber(body.bed + this.state.t_bed);
            this.state.t_bes = this.FixedPointNumber(body.bes + this.state.t_bes);
            return body;
        });

        if (field === 'moeinCode') this.newBodyRow(null);
        this.setState({
            data: {
                ...this.state.data,
                bodies: updatedBodies
            },
            bodyVersion: this.uuidv4()
        });
    }

    newBodyRow(e, force = 0) {
        if (!this.isNull(e)) e.preventDefault();

        var hasEmptyRow = false;

        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].moeinCode === 0) {
                hasEmptyRow = true;
            }
        }

        if (!hasEmptyRow || force == 1) {
            this.state.data.bodies.push(this.getBlankRow());
            this.setState({ data: this.state.data });
        }
    }
    getBlankRow(defaultIndex = null) {
        return {
            id: this.uuidv4(),
            index: (defaultIndex == null ? this.state.data.bodies.length + 1 : defaultIndex),
            moeinCode: 0,
            tafsilCode: 0,
            bed: 0,
            bes: 0,
            description: ''
        }
    }
    removeBodyRow(e, id) {
        e.preventDefault();
        var temp = [];
        var index = 1;
        this.state.t_bed = 0; // مقداردهی اولیه برای محاسبه مجدد
        this.state.t_bes = 0; // مقداردهی اولیه برای محاسبه مجدد

        this.state.data.bodies.sort((a, b) => a.index - b.index).forEach(r => {
            if (r.id != id) {
                temp.push(r);
                temp[temp.length - 1].index = index;
                index++;
                // محاسبه مقادیر t_bed و t_bes مجدداً پس از حذف ردیف
                this.state.t_bed = this.FixedPointNumber(r["bed"] + this.state.t_bed);
                this.state.t_bes = this.FixedPointNumber(r["bes"] + this.state.t_bes);
            }
        });
        this.state.data.bodies = temp;
        this.setState({ data: this.state.data });
    }
    upIndex(id) {
        var temp = [];
        var index = 1;
        var idIndex = -1;
        this.state.data.bodies.sort((a, b) => a.index - b.index).forEach(r => {
            if (r.id == id) idIndex = index - 1;
            temp.push(r);
            temp[temp.length - 1].index = index;
            index++;
        });
        if (idIndex != -1 && idIndex > 0) {
            temp[idIndex].index = temp[idIndex].index - 1;
            temp[idIndex - 1].index = temp[idIndex].index + 1;
            this.state.data.bodies = temp;
            this.setState({ data: this.state.data });
        }
    }
    downIndex(id) {
        var temp = [];
        var index = 1;
        var idIndex = -1;
        this.state.data.bodies.sort((a, b) => a.index - b.index).forEach(r => {
            if (r.id == id) idIndex = index - 1;
            temp.push(r);
            temp[temp.length - 1].index = index;
            index++;
        }); console.log(idIndex);
        if (idIndex != -1 && idIndex < temp.length - 1) {
            temp[idIndex].index = temp[idIndex].index + 1;
            temp[idIndex + 1].index = temp[idIndex].index - 1;
            this.state.data.bodies = temp;
            this.setState({ data: this.state.data });
        }
    }

    loadAccountOptions(inputValue, callback, type, parentCode, tafsilType4, tafsilType5) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getaccounts/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "type": type,
                    "parentCode": parseInt(parentCode),
                    "tafsilType4": parseInt(tafsilType4),
                    "tafsilType5": parseInt(tafsilType5),
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.fullCode,
                            label: (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ fontWeight: 'bold', margin: '0 5px', lineHeight: '30px' }}>{_record.fullCode}</span>
                                    <i className="bi bi-caret-left me-2"></i>
                                    <span>{_record.title}</span>
                                </div>
                            ),
                            moeinDetailed: _record.detailed,
                            moeinDetailed5: _record.detailed5,
                            tafsilType4: _record.tafsilType4,
                            tafsilType5: _record.tafsilType5
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }

    loadMoienAccountOptions(inputValue, callback) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getMoienAccounts/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.fullCode,
                            label: (
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span style={{ fontWeight: 'bold', margin: '0 5px', lineHeight: '30px' }}>{_record.fullCode}</span>
                                    <i className="bi bi-caret-left me-2"></i>
                                    <span>{_record.title}</span>
                                </div>
                            ),
                            moeinDetailed: _record.detailed,
                            moeinDetailed5: _record.detailed5,
                            tafsilType4: _record.tafsilType4,
                            tafsilType5: _record.tafsilType5
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }

    handleOpenModal = (documentItemId) => { // Pass the button ID when opening the modal

        const { data } = this.state;
        var currentArchiveIds = data.bodies.find(e => e.id == documentItemId).archiveIds;

        if (!currentArchiveIds)
            currentArchiveIds = [];

        this.setState({ modalOpen: true, documentItemId: documentItemId, currentArchiveIds: currentArchiveIds });

        console.log("Document.handleOpenModal : ", "documentItemId : ", documentItemId, "currentArchiveIds :", currentArchiveIds);
    };
    handleClose = () => {
        this.setState({ modalOpen: false, documentItemId: '', currentArchiveIds: [] });
    };
    archiveCallBack = (documentItemId, archiveIds) => {


        //console.log(documentItemId);
        //console.log(ArchiveIds);
        //console.log(this.state);

        const { data } = this.state;

        var body = data.bodies.find(e => e.id == documentItemId);
        body.archiveIds = archiveIds;

        //console.log('body : ', body);

        this.setState({ data, modalOpen: false, documentItemId: '', currentArchiveIds: [] });

        //console.log('bodies : ', this.state.data.bodies);

    };

    handleKeyDown = (event, record, field) => {
        if (event.key === 'F2') {
            const index = this.state.data.bodies.findIndex(item => item.id === record.id);
            if (index > 0) {
                const previousRecord = this.state.data.bodies[index - 1];
                this.setBodyValue(record.id, field, previousRecord[field]);
            }
        } else if (event.key === 'F3') {
            if (field === 'bed' || field === 'bes') {
                if (field === 'bed') {
                    const value = record.bed;
                    this.setBodyValue(record.id, 'bes', value);
                    this.setBodyValue(record.id, 'bed', 0);
                } else if (field === 'bes') {
                    const value = record.bes;
                    this.setBodyValue(record.id, 'bed', value);
                    this.setBodyValue(record.id, 'bes', 0);
                }
            }
        }
    }

    renderForm() {
        console.log(this.state)

        const { modalOpen, documentItemId, data, currentArchiveIds } = this.state;
        return (
            <>
                <DocumentModal open={modalOpen} documentItemId={documentItemId} archiveIds={currentArchiveIds} archives={data.archives ? data.archives : []} onArchiveSaved={this.archiveCallBack} onClose={this.handleClose} />

                <form onSubmit={e => this.save(e)} className="row g-4">
                    <div className="nk-block-head">
                        <div className="nk-block-between g-3">
                            <div className="nk-block-head-content">
                                <h3 className="nk-block-title page-title">اطلاعات سند</h3>
                            </div>
                            <div className="nk-block-head-content">
                                {!this.isNull(this.state.data.invoice) && <NavLink to={"/invoice/" + (this.state.data.invoice.mainType == 1 ? "sale" : this.state.data.invoice.mainType == 2 ? "buy" : "") + "/edit/" + this.state.data.invoice.id} className="me-2 btn btn-primary"><span>صورتحساب شماره {this.state.data.invoice.inno}</span></NavLink>}
                                {!this.isNull(this.state.data.remittance) && <NavLink to={"/remittance/edit/" + this.state.data.remittance.id} className="me-2 btn btn-warning"><span>{this.state.data.remittance.io == 1 ? "رسید" : ""}{this.state.data.remittance.io == 2 ? "حواله" : ""} شماره {this.state.data.remittance.number}</span></NavLink>}
                                <NavLink to="/documents/" className="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em className="icon ni ni-arrow-left"></em><span>برگشت</span></NavLink>
                                <NavLink to="/documents" className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"><em className="icon ni ni-arrow-left"></em></NavLink>
                                {this.state.data.record.id != this.defaultGuid() && <a onClick={e => this.getPdf(e)} className="btn btn-white btn-outline-light"><em className="icon ni ni-file-pdf"></em><span>خروجی PDF</span></a>}
                            </div>
                        </div>
                    </div>

                    <div className="card card-bordered card-preview">
                        <div className="card-inner">
                            <div className="card-head"><h5 className="card-title">مشخصات سند</h5></div>
                            <div className="row g-4">
                                <div className="col-md-2">
                                    <div className="container" id="invoiceCustomerBox">
                                        <div className="form-group">
                                            <label className="form-label">نوع</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control text-center" defaultValue={this.state.data.record.type} onChange={e => this.state.data.record.type = parseInt(e.target.value)}>
                                                    <option value="1">عادی</option>
                                                    <option value="2">افتتاحیه</option>
                                                    <option value="3">اختتامیه</option>
                                                    <option value="4">بستن حساب موقت</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="container">
                                        <div className="form-group">
                                            <label className="form-label">وضعیت</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control text-center" defaultValue={this.state.data.record.status} onChange={e => this.state.data.record.status = parseInt(e.target.value)}>
                                                    <option value="1">یادداشت</option>
                                                    <option value="2">موقت</option>
                                                    <option value="3">قطعی</option>
                                                    <option value="4">نهایی</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="container">
                                        <div className="form-group">
                                            <label className="form-label">تاریخ</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control text-center ltr" type="text" defaultValue={this.state.data.record.datePersian} onChange={e => this.state.data.record.datePersian = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="container">
                                        <div className="form-group">
                                            <label className="form-label">شماره سند</label>
                                            <div className="form-control-wrap">
                                                <NumberFormat value={this.state.data.record.number} onChange={e => this.state.data.record.number = parseInt(e.target.value.replace(/,/g, ''))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="container">
                                        <div className="form-group">
                                            <label className="form-label">شماره عطف</label>
                                            <div className="form-control-wrap">
                                                <NumberFormat value={this.state.data.record.refNumber} onChange={e => this.state.data.record.refNumber = parseInt(e.target.value.replace(/,/g, ''))} thousandSeparator={false} prefix={''} className='form-control text-center ltr' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="container" id="invoiceCustomerBox">
                                        <div className="form-group">
                                            <label className="form-label">شرح سند</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control" type="text" defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value}></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="container" id="invoiceCustomerBox">
                                        <div className="form-group">
                                            <label className="form-label">یادداشت</label>
                                            <div className="form-control-wrap">
                                                <input className="form-control" type="text" defaultValue={this.state.data.record.note} onChange={e => this.state.data.record.note = e.target.value}></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card card-bordered card-preview">
                        <div className="card-inner">
                            <div className="card-head"><h5 className="card-title">اقلام سند</h5></div>
                            <table className="table table-ulogs invoceEntryTable">
                                <thead className="table-light">
                                    <tr>
                                        <th className="text-center" style={{ "width": "50px" }}><span className="overline-title">ردیف</span></th>
                                        <th className="text-center" style={{ "width": "180px" }}><span className="overline-title">معین</span></th>
                                        <th className="text-center" style={{ "width": "180px" }}><span className="overline-title">تفصیل 4</span></th>
                                        <th className="text-center" style={{ "width": "180px" }}><span className="overline-title">تفصیل 5</span></th>
                                        <th className="text-center"><span className="overline-title">شرح</span></th>
                                        <th className="text-center" style={{ "width": "85px" }}><span className="overline-title">مبلغ بدهکار</span></th>
                                        <th className="text-center" style={{ "width": "85px" }}><span className="overline-title">مبلغ بستانکار</span></th>
                                        {/*                                        <th className="text-center">آرشیو</th>*/}
                                        <th className="tb-col-action" style={{ "width": "65px" }}></th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {this.state.data.bodies.sort((a, b) => a.index - b.index).map((record, index) =>
                                        <tr key={record.id}>
                                            <td className="text-center align-middle">{index + 1}</td>
                                            <td>
                                                <SelectAsync
                                                    ref={this.moeinRef}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: 30, // حداقل ارتفاع باکس
                                                            height: 35, // ارتفاع باکس
                                                            fontSize: 10, // تنظیم اندازه فونت
                                                            display: 'flex', // استفاده از flex برای ترتیب‌دهی فرزندان
                                                            alignItems: 'center' // وسط قرار دادن فرزندان به صورت عمودی
                                                        }),
                                                        menu: (base) => ({
                                                            ...base,
                                                            fontSize: 10 // تنظیم اندازه فونت در منوی انتخاب
                                                        }),
                                                        singleValue: (base) => ({
                                                            ...base,
                                                            display: 'flex', // استفاده از flex برای ترتیب‌دهی فرزندان
                                                            alignItems: 'center', // وسط قرار دادن فرزندان به صورت عمودی
                                                            whiteSpace: 'normal', // اجازه به شکستن خطوط متن
                                                            textOverflow: 'initial' // جلوگیری از نشان دادن ...
                                                        }),
                                                        indicatorSeparator: () => ({ display: 'none' }), // حذف جداکننده فلش
                                                        dropdownIndicator: () => ({ display: 'none' }) // حذف فلش پایین‌رو
                                                    }}
                                                    defaultValue={!this.isNull(record.moeinAccount) ? {
                                                        value: record.moeinAccount.fullCode, label: (
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <span style={{ fontWeight: 'bold', margin: '0 5px', lineHeight: '30px' }}>{record.moeinAccount.fullCode}</span>
                                                                <i className="bi bi-caret-left me-2"></i>
                                                                <span>{record.moeinAccount.title}</span>
                                                            </div>
                                                        )
                                                    } : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب حساب معین"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadMoienAccountOptions(inputValue, callback)}
                                                    onChange={e => { this.updateStateForMoeinCode(index, e); this.setBodyValue(record.id, 'moeinCode', e); }}
                                                />
                                            </td>

                                            <td className="document-custom">
                                                {record.moeinDetailed && (
                                                    <SelectAsync
                                                        key={`tafsil4-${index}-${this.state.tafsilOptions4[index]?.length}`}
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                minHeight: 30, // حداقل ارتفاع باکس
                                                                height: 35, // ارتفاع باکس
                                                                fontSize: 10, // تنظیم اندازه فونت
                                                                display: 'flex', // استفاده از flex برای ترتیب‌دهی فرزندان
                                                                alignItems: 'center' // وسط قرار دادن فرزندان به صورت عمودی
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: 10 // تنظیم اندازه فونت در منوی انتخاب
                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                display: 'flex', // استفاده از flex برای ترتیب‌دهی فرزندان
                                                                alignItems: 'center', // وسط قرار دادن فرزندان به صورت عمودی
                                                                whiteSpace: 'normal', // اجازه به شکستن خطوط متن
                                                                textOverflow: 'initial' // جلوگیری از نشان دادن ...
                                                            }),
                                                            indicatorSeparator: () => ({ display: 'none' }), // حذف جداکننده فلش
                                                            dropdownIndicator: () => ({ display: 'none' }) // حذف فلش پایین‌رو
                                                        }}
                                                        defaultValue={!this.isNull(record.tafsilAccount) ? {
                                                            value: record.tafsilAccount.fullCode, label: (
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <span style={{ fontWeight: 'bold', margin: '0 5px', lineHeight: '30px' }}>{record.tafsilAccount.fullCode}</span>
                                                                    <i className="bi bi-caret-left me-2"></i>
                                                                    <span>{record.tafsilAccount.title}</span>
                                                                </div>
                                                            )
                                                        } : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب تفصیل سطح چهارم"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => {
                                                            setTimeout(() => {
                                                                this.loadAccountOptions(inputValue, callback, 4, record.moeinCode, record.tafsilType4, record.tafsilType5);
                                                            }, 200);
                                                        }}

                                                        onChange={e => this.setBodyValue(record.id, 'tafsilCode', e)}
                                                    />
                                                )}
                                            </td>



                                            <td>
                                                {record.moeinDetailed5 && (
                                                    <SelectAsync
                                                        key={`tafsil5-${index}-${this.state.tafsilOptions5[index]?.length}`}
                                                        styles={{
                                                            control: (base) => ({
                                                                ...base,
                                                                minHeight: 30, // حداقل ارتفاع باکس
                                                                height: 35, // ارتفاع باکس
                                                                fontSize: 10, // تنظیم اندازه فونت
                                                                display: 'flex', // استفاده از flex برای ترتیب‌دهی فرزندان
                                                                alignItems: 'center' // وسط قرار دادن فرزندان به صورت عمودی
                                                            }),
                                                            menu: (base) => ({
                                                                ...base,
                                                                fontSize: 10 // تنظیم اندازه فونت در منوی انتخاب
                                                            }),
                                                            singleValue: (base) => ({
                                                                ...base,
                                                                display: 'flex', // استفاده از flex برای ترتیب‌دهی فرزندان
                                                                alignItems: 'center', // وسط قرار دادن فرزندان به صورت عمودی
                                                                whiteSpace: 'normal', // اجازه به شکستن خطوط متن
                                                                textOverflow: 'initial' // جلوگیری از نشان دادن ...
                                                            }),
                                                            indicatorSeparator: () => ({ display: 'none' }), // حذف جداکننده فلش
                                                            dropdownIndicator: () => ({ display: 'none' }) // حذف فلش پایین‌رو
                                                        }}
                                                        defaultValue={!this.isNull(record.tafsilAccount5) ? {
                                                            value: record.tafsilAccount5.fullCode, label: (
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <span style={{ fontWeight: 'bold', margin: '0 5px', lineHeight: '30px' }}>{record.tafsilAccount5.fullCode}</span>
                                                                    <i className="bi bi-caret-left me-2"></i>
                                                                    <span>{record.tafsilAccount5.title}</span>
                                                                </div>
                                                            )
                                                        } : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب تفصیل سطح پنجم"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => {
                                                            setTimeout(() => {
                                                                this.loadAccountOptions(inputValue, callback, 5, record.moeinCode, record.tafsilType4, record.tafsilType5);
                                                            }, 200);
                                                        }}
                                                        onChange={e => this.setBodyValue(record.id, 'tafsilCode5', e)}
                                                    />
                                                )}
                                            </td>


                                            <td>
                                                <input
                                                    type="text"
                                                    style={{
                                                        width: "100%", // پهنای کامل
                                                        minHeight: "30px", // حداقل ارتفاع باکس
                                                        height: "35px", // ارتفاع باکس
                                                        fontSize: "10px", // تنظیم اندازه فونت
                                                        overflow: "visible", // نمایش کامل محتوا
                                                        whiteSpace: "normal" // اجازه به شکستن خطوط متن
                                                    }}
                                                    placeholder="شرح سند"
                                                    defaultValue={record.description}
                                                    onChange={e => this.setBodyValue(record.id, 'description', e.target.value)}
                                                    className='form-control'
                                                    onKeyDown={e => this.handleKeyDown(e, record, 'description')}
                                                />
                                            </td>


                                            <td>
                                                <NumberFormat
                                                    style={{
                                                        width: "80px", // عرض ثابت
                                                        minHeight: "30px", // حداقل ارتفاع باکس
                                                        height: "35px", // ارتفاع باکس
                                                        fontSize: "10px", // تنظیم اندازه فونت
                                                        overflow: "visible", // نمایش کامل محتوا
                                                        whiteSpace: "normal" // اجازه به شکستن خطوط متن
                                                    }}
                                                    value={record.bed}
                                                    onValueChange={(values) => {
                                                        const { floatValue } = values;
                                                        this.setBodyValue(record.id, 'bed', floatValue !== undefined ? floatValue : 0);
                                                    }}
                                                    thousandSeparator={true}
                                                    prefix={''}
                                                    className='form-control'
                                                    onKeyDown={(e) => this.handleKeyDown(e, record, 'bed')}
                                                />
                                            </td>
                                            <td>
                                                <NumberFormat
                                                    style={{
                                                        width: "80px", // عرض ثابت
                                                        minHeight: "30px", // حداقل ارتفاع باکس
                                                        height: "35px", // ارتفاع باکس
                                                        fontSize: "10px", // تنظیم اندازه فونت
                                                        overflow: "visible", // نمایش کامل محتوا
                                                        whiteSpace: "normal" // اجازه به شکستن خطوط متن
                                                    }}
                                                    value={record.bes}
                                                    onValueChange={(values) => {
                                                        const { floatValue } = values;
                                                        this.setBodyValue(record.id, 'bes', floatValue !== undefined ? floatValue : 0);
                                                    }}
                                                    thousandSeparator={true}
                                                    prefix={''}
                                                    className='form-control'
                                                    onKeyDown={(e) => this.handleKeyDown(e, record, 'bes')}
                                                />
                                            </td>
                                            {/*<td>*/}

                                            {/*    */}{/*<Button variant="contained" color="primary" onClick={() => this.handleOpenModal(record.id)}>*/}
                                            {/*    */}{/*    <ArchiveIcon fontSize="small" />*/}
                                            {/*    */}{/*</Button>*/}


                                            {/*</td>*/}
                                            <td className="tb-col-action">
                                                <a onClick={e => this.removeBodyRow(e, record.id)} className="link-cross me-sm-n1 hand"><em className="icon ni ni-cross"></em></a>
                                                {index < (this.state.data.bodies.length - 1) && <a onClick={e => this.downIndex(record.id)} className="link-cross me-sm-n1 hand"><em className="icon ni ni-chevron-down"></em></a>}
                                                {index > 0 && <a onClick={e => this.upIndex(record.id)} className="link-cross me-sm-n1 hand"><em className="icon ni ni-chevron-up"></em></a>}
                                            </td>
                                        </tr>
                                    )}



                                </tbody>
                                <tfoot>
                                    <tr style={{ "background-color": "#e9e8e1" }}>
                                        <td className="text-center" colSpan="3">
                                            <label>جمع کل</label>
                                        </td>
                                        <td className="text-center">
                                        </td>
                                        <td></td>
                                        <td className="text-center">
                                            <label>{this.money(this.state.t_bed)}</label>
                                        </td>
                                        <td className="text-center">
                                            <label>{this.money(this.state.t_bes)}</label>
                                        </td>

                                        <td></td>


                                    </tr>
                                    <tr>
                                        <td colSpan="5">
                                            <a className="btn btn-dim btn-round btn-sm btn-primary hand" onClick={e => this.newBodyRow(e, 1)}><em className="icon ni ni-grid-add-c"></em> <span>افزودن سطر جدید</span></a>
                                        </td>
                                        <td colSpan="3">
                                            <div className={this.state.t_bed - this.state.t_bes === 0 ? 'alert alert-success' : 'alert alert-danger'}>
                                                <label style={{ fontSize: '0.9em' }}> مغایرت سند :</label>
                                                <label style={{ fontSize: '0.9em' }} className="ms-4">
                                                    {(this.state.t_bed - this.state.t_bes) === 0
                                                        ? '0'
                                                        : (this.state.t_bed - this.state.t_bes) < 0
                                                            ? `(${this.money(Math.abs(this.state.t_bed - this.state.t_bes))})`
                                                            : this.money(this.state.t_bed - this.state.t_bes)}
                                                </label>
                                            </div>
                                        </td>


                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <div className="form-group">
                        <button type="submit" className="btn btn-primary"><em className="icon ni ni-save"></em> ذخیره</button>
                    </div>
                </form>
            </>

        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}